import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-8 flex"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "ml-auto flex gap-4 text-xs uppercase md:gap-6" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  width: "10",
  height: "10",
  style: {"transform":"rotate(180deg)"},
  focusable: "false",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.showNavigation)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.searchUrl)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: _ctx.searchUrl,
              class: "flex items-center gap-1"
            }, [
              _cache[2] || (_cache[2] = _createElementVNode("svg", {
                width: "10",
                height: "10",
                focusable: "false",
                "aria-hidden": "true"
              }, [
                _createElementVNode("use", { "xlink:href": "#arrow-left" })
              ], -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.t('searchResult')), 1)
            ], 8, _hoisted_2))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          (_ctx.prev)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: _ctx.objectUrl(_ctx.prev),
                class: "flex items-center gap-1",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.decIndex && _ctx.decIndex(...args)))
              }, [
                _cache[3] || (_cache[3] = _createElementVNode("svg", {
                  width: "10",
                  height: "10",
                  focusable: "false",
                  "aria-hidden": "true"
                }, [
                  _createElementVNode("use", { "xlink:href": "#arrow-left" })
                ], -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.t('previous')), 1)
              ], 8, _hoisted_4))
            : _createCommentVNode("", true),
          (_ctx.next)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: _ctx.objectUrl(_ctx.next),
                class: "flex items-center gap-1",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.incIndex && _ctx.incIndex(...args)))
              }, [
                _createTextVNode(_toDisplayString(_ctx.t('next')) + " ", 1),
                (_openBlock(), _createElementBlock("svg", _hoisted_6, [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("use", { "xlink:href": "#arrow-left" }, null, -1)
                ]))]))
              ], 8, _hoisted_5))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}